import React from 'react';
import {
  SaveButton,
  NumberInput,
  required,
  minValue,
  maxValue,
  RecordContextProvider,
  useRecordContext,
  TextInput,
  usePermissions,
  TextField,
  Labeled,
} from 'react-admin';

import { useFormContext } from 'react-hook-form';

import {
  Box,
  Grid,
} from '@mui/material';

import hasAccess from '../../utilities/hasAccess';

import EditDialog from '../layout/dialog/EditDialog';
import InfoPopover from '../layout/InfoPopover';

import ActivationButton from '../../customFields/ActivationButton';

import actions, { Actions } from '../../constants/actions';
import resourceTypes from '../../constants/resourceTypes';
import RiskClassInput from '../../customFields/RiskClassInput';

const CustomToolbar = () => {
  const { formState: { isValid } } = useFormContext();
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Box display="flex" justifyContent="space-between" gap={2} marginTop={4}>
      {hasAccess(permissions, actions.GROUP_UPDATE_ACTIVATION) && (
        <ActivationButton />
      )}
      {hasAccess(permissions, actions.GROUP_UPDATE) && (
        <SaveButton
          disabled={!isValid}
          icon={null}
        />
      )}
    </Box>
  );
};

const GroupEdit = () => {
  const record = useRecordContext();

  return (
    <EditDialog
      customToolbar={<CustomToolbar />}
      title="group"
      action={actions.GROUP_GET}
      resourceType={resourceTypes.GROUP}
    >
      <RecordContextProvider value={record}>
        <Grid container spacing={6}>
          <Grid size={12}>
            <Labeled label="ID">
              <TextField source="id" />
            </Labeled>
          </Grid>
          <Grid size={12}>
            <Labeled label="Name">
              <TextInput fullWidth validate={required()} source="name" label="" helperText={false} />
            </Labeled>
          </Grid>
          <Grid size={12}>
            <Labeled
              label={(
                <>
                  Default risk (%)
                  <InfoPopover title="Default risk" content="Probability of financial crime activity given which entity is in that group." />
                </>
              )}
            >
              <NumberInput fullWidth validate={[required(), maxValue(99), minValue(0)]} source="score" label="" helperText={false} />
            </Labeled>
          </Grid>
          <Grid size={12}>
            <Labeled
              label={(
                <>
                  Corresponding risk class
                  <InfoPopover title="Corresponding risk classes" content="The risk class corresponding to the default risk chosen." />
                </>
              )}
            >
              <RiskClassInput source="score" />
            </Labeled>
          </Grid>
        </Grid>
      </RecordContextProvider>
    </EditDialog>
  );
};

export default GroupEdit;
